import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;

export const Skeleton = styled.div`
  height: ${(p) => p.$h || "14px"};
  width: ${(p) => p.$w || "100%"};
  border-radius: ${(p) => p.$radius || "6px"};
  background: linear-gradient(90deg, #F2F4F7 25%, #E9EAEB 37%, #F2F4F7 63%);
  background-size: 400px 100%;
  animation: ${shimmer} 1.4s ease infinite;
  flex-shrink: 0;
`;

export const SkeletonCircle = styled(Skeleton).attrs((p) => ({ $radius: "50%" }))``;

export const SkeletonText = styled(Skeleton).attrs((p) => ({ $h: p.$h || "13px" }))``;

export const SkeletonRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export default Skeleton;
